import {AbstractModel} from './abstract-model';
import {Document} from './document';

export class News extends AbstractModel {
  id: number | null = null;
  title: string = '';
  excerpt: string = '';
  content: string = '';
  publishedAt: Date | null = null;
  createdAt: Date | null = null;

  image: Document | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.image) {
      this.image = new Document().deserialize(input.image);
    }

    return this;
  }

}
